namespace GeniuzPOS.Purchase {
    export interface ReportPendingPRDtRow {
        Id?: number;
        SysDocNo?: string;
        UseFg?: number;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        Qty?: number;
        UnitQty?: number;
        PurUnit?: string;
        StkQty?: number;
        QtyUse?: number;
        StkUnit?: string;
        LessQty?: number;
        UnitCost?: number;
        LessCost?: number;
        Remark?: string;
        PoRefDocNo?: string;
    }

    export namespace ReportPendingPRDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.ReportPendingPRDt';
        export const lookupKey = 'Purchase.ReportPendingPRDt';

        export function getLookup(): Q.Lookup<ReportPendingPRDtRow> {
            return Q.getLookup<ReportPendingPRDtRow>('Purchase.ReportPendingPRDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            Qty = "Qty",
            UnitQty = "UnitQty",
            PurUnit = "PurUnit",
            StkQty = "StkQty",
            QtyUse = "QtyUse",
            StkUnit = "StkUnit",
            LessQty = "LessQty",
            UnitCost = "UnitCost",
            LessCost = "LessCost",
            Remark = "Remark",
            PoRefDocNo = "PoRefDocNo"
        }
    }
}
